import {
    ENVIAR_INVITACION_PACIENTE,
    ENVIAR_INVITACION_PACIENTE_EXITO,
    ENVIAR_INVITACION_PACIENTE_ERROR,
    CARGAR_DATOS_PACIENTE_NO_REGISTRADO,
    CARGAR_DATOS_PACIENTE_NO_REGISTRADO_EXITO,
    MOSTRAR_ALERTA
} from '../types';
import clienteAxios from '../config/axios';

export function enviarInvitacionPacienteAction(informacion) {

    return async dispatch => {

        dispatch(
            enviarInvitacionPaciente()
        );


        try {

            const {
                config,
                payload
            } = informacion;


            const respuesta =
                await clienteAxios.post(

                    '/paciente/enviarinvitacionpaciente',

                    payload,

                    config

                );


            dispatch(
                enviarInvitacionPacienteExito(
                    respuesta.data.msg
                )
            );


            return {

                ok:
                    true,

                data:
                    respuesta.data

            };


        } catch (
            error
        ) {

            const mensaje =
                error.response?.data ||
                {
                    msg:
                        'No se pudo enviar la invitación'
                };


            dispatch(
                enviarInvitacionPacienteError(
                    mensaje
                )
            );


            return {

                ok:
                    false,

                error:
                    mensaje

            };

        }

    };

}

const enviarInvitacionPaciente = () => ({
    type: ENVIAR_INVITACION_PACIENTE,
    payload: true
});
const enviarInvitacionPacienteExito = (msg) => ({
    type: ENVIAR_INVITACION_PACIENTE_EXITO,
    payload: msg
});
const enviarInvitacionPacienteError = (msg) => ({
    type: ENVIAR_INVITACION_PACIENTE_ERROR,
    payload: msg
});

export function cargarDatosPacienteNoRegistradoAction(
    informacion
) {

    return async dispatch => {

        dispatch(
            cargarDatosPacienteNoRegistrado()
        );


        try {

            const {
                payload
            } = informacion;


            const respuesta =
                await clienteAxios.post(
                    '/paciente/cargardatospacientenoregistrado',
                    payload
                );


            dispatch(
                cargarDatosPacienteNoRegistradoExito(
                    respuesta.data.msg
                )
            );


            return {

                ok:
                    true,

                data:
                    respuesta.data.msg

            };


        } catch (
            error
        ) {

            const mensaje =
                error.response?.data ||
                {
                    msg:
                        'No se pudieron cargar los datos de la invitación'
                };


            dispatch(
                mostrarAlerta(
                    mensaje
                )
            );


            return {

                ok:
                    false,

                error:
                    mensaje

            };

        }

    };

}

const cargarDatosPacienteNoRegistrado = () => ({
    type: CARGAR_DATOS_PACIENTE_NO_REGISTRADO,
    payload: true
});
const cargarDatosPacienteNoRegistradoExito = (msg) => ({
    type: CARGAR_DATOS_PACIENTE_NO_REGISTRADO_EXITO,
    payload: msg
});
// si hubo un error
const mostrarAlerta = (alerta) => ({
    type: MOSTRAR_ALERTA,
    payload: alerta
});